import React,{useState,useEffect} from 'react';
import { Link, useHistory } from 'react-router-dom';
import Logo from './img/logo.png';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DatePicker,{registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './styles/Login.css';
import ko from "date-fns/locale/ko";
import {formatDate,phoneFormat, Select,currentDate,AxiosInsert,axiosDefault,axiosParams,instance, biznumFormat} from './common';
import {DupliSpan,userJoin} from './axios/user';
import Postcode from './Postcode';
import queryString from 'query-string';
import YakGawn from './YakGawn';
import { useMediaQuery } from "react-responsive";
import classes from "./components/Register/Register.module.css";
import CarStoreInfo from './components/Register/CarStoreInfo';
import SigongInfo from './components/Register/SigongInfo';

registerLocale("ko", ko);

function MustModal({type}){
    const style = {
        fontSize:'12px',
        color:'#06f',
        textDecoration:'underline',
        textUnderlinePosition: 'under',
        cursor:'pointer'
    }

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const closeBtn = <button className="close" onClick={toggle}>&times;</button>;
    return (
        <>
        <span style={style} onClick={toggle}>(필수)</span>
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>{type}</ModalHeader>
            <ModalBody>
                <YakGawn type={type}/>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>닫기</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}
function Test({refer,referChange}) {
    const [resp, setGitData] = useState({ data: [], repos: [] });
    let obj = {
        refer:refer
    }
    useEffect(() => {
      const fetchData =     async () => {
        const respGlobal = axiosDefault();
        const respRepos = axiosParams(obj);
  
        setGitData({ data: respGlobal.data, repos: respRepos.data });
      };
  
      fetchData();
    }, [refer]);
  
  
    return (
        <>
            <div className="col-6 pl-0">
            <select className="form-control" onChange={referChange}>
                {resp.data.map(v => <option key={v.no} value={v.id}>{v.cate_name}</option>)}
            </select>
            </div>
            <div className="col-6 pr-0">
                <select name="u_car_name" className="form-control">
                    {resp.repos.map((v,i) => i === 0 ? <option key={i} value="">-</option> : <option key={v.no} value={v.cate_name}>{v.cate_name}</option>)}
                </select>
            </div>
        </>
    );
}


function loadAgency(ag_area){
    console.log('함수시작 : ', ag_area);


    instance.post('/agency/agency',{
        ag_area:ag_area
    })
    .then(function (response) {
        // handle success
        const data = response.data;
        console.log('data : ', data);
        if(data.length !==0){
            let str = '<option value="">-</option>';
            data.forEach(v => {
                str += '<option value="'+v.ag_agency+'">'+v.ag_agency+'</option>';
                
            });
            document.getElementById('agency-select').innerHTML = str;

        }  
    
        
    })
    .catch(function (error) {
        // handle error
        console.log(error);
    })
}

function Register({ location }){
    const history = useHistory();
    let insertCnt = 0;
    const [isMaster, setIsMaster] = useState(false);
    const [tvTech, setTvTech] = useState(false);
    
    let query = '';
    if(query){
        query = queryString.parse(location.search);
        // console.log('왜탐?')
    }
    console.log('query : ', query)
    const {kind,social_email} = query;
    console.log('kind : ', kind)
    const [u_dealer_agency, setAgency] = useState({
        ag_id:'',
        ag_type:'',
        ag_area:'',
        ag_agency:'',
    });

    const [sigong, setSigong] = useState({
        si_id:'',
        si_area1:'',
        si_area2:'',
        si_name:'',
    });

    
  const [bannerType, setBannerType] = useState("");
    useEffect(() => {
   
        setBannerType("");
      
     
  }, [bannerType]);
    
 
    const [checkedItems, setCheckedItems] = useState(new Set());
    const checkedItemHandler = (id, isChecked) => {
        if (isChecked) {
          checkedItems.add(id);
          setCheckedItems(checkedItems);
        } else if (!isChecked && checkedItems.has(id)) {
          checkedItems.delete(id);
          setCheckedItems(checkedItems);
        }
      };
    const [bChecked, setChecked] = useState(false);


    // 데이트피커
    const [startDate, setStartDate] = useState('');

    //중복검사 여부
    const [duInput, setDuInput] = useState({
        du_id:false,
        du_nick:false
    });

    //차량등록 select change
    
    const [refer, setRefer] = useState('1010');

    const referChange = (e) => {

        setRefer(e.target.value);
    }
    

     // input 값들 객체로 관리
    const [inputs, setInputs] = useState({
        u_type:'일반고객',
        u_regdate:currentDate(),
        u_login_id:'',
        u_pwd:'',
        u_nick:'',
        u_phone:'',
        u_agree:false,
        u_address1:'',
        u_address2:'',
        u_social:'',
        u_company_num:'',
        u_company_name:'',
        u_bank:'',
        u_holder:'',
        u_account:'',
        u_sigong:'',
        u_email:'',
        u_dam:'',
        u_dam_num:'',
        u_brand:'',
        u_tv_tech:'N',
        u_sa_address_1:'',
        u_sa_address_2:'',
        u_sa_address_3:'',
        
    });


    const [repCar, setRepCar] = useState({
        u_car_name:'',
        u_car_number:'',
        u_car_age:'',
        u_car_color:'',
        u_car_date:'',
        u_app_date:currentDate(),
    })

    const {u_car_name,u_car_number,u_car_age,u_car_color,u_car_date} = repCar;

    const {u_type,u_login_id,u_pwd,u_nick,u_phone,u_address1,u_address2,u_company_num,u_company_name,u_bank,u_holder,
        u_account,u_sigong,u_email,u_dam,u_dam_num,u_brand,u_tv_tech,u_sa_address_1,u_sa_address_2,u_sa_address_3} = inputs;


    const checkHandler = ({ target }) => {
        setChecked(!bChecked);
        checkedItemHandler(target.checked);
        if(target.checked){
            console.log('df', u_nick);
           // u_dam = u_nick
           inputs.u_dam = u_nick
        }
      };

      const brandChange = (e) => {
        this.setState({selectedValue: e.target.value})
      }

    const [carNumbers, setCarNumber] = useState({
        u_car_f:'',
        u_car_s:'',
        u_car_l:'',
    })

    const [checkedList, setCheckedList] = useState([]);
    // 1️⃣ onChange함수를 사용하여 이벤트 감지, 필요한 값 받아오기
    const onCheckedElement = (checked, item) => {
        
      if (checked) {
        setCheckedList([...checkedList, item]);
      } else if (!checked) {
        setCheckedList(checkedList.filter(el => el !== item));
      }
    };
    console.log('check',checkedList);

    useEffect(() => {
      
        if(kind){
            setInputs({
                ...inputs,
                u_social:kind,
                u_login_id:social_email
            })

            setDuInput({
                ...duInput,
                du_id:true
            });
        }
    
      }, []);
    
      const [checkholder, setcheckholder] = useState(0);
      const [brand, setBrand] = useState(Array);
    const {u_car_f,u_car_s,u_car_l} = carNumbers;

    // input 값들 Change 함수
    

    const onChange = (e) => {
        let {name,value} = e.target;
        
      
        // u_sigong = sigong.si_id
        

        if (name === 'u_type') {

            value === '시공지점'? setIsMaster(true) : setIsMaster(false)
        }

        if(name === 'u_tv_tech'){

            value === 'Y'? setTvTech(true) : setTvTech(false)
        }

        if(name === 'u_phone')  value = phoneFormat(value);
        
        if(name === 'u_dam_num')  value = phoneFormat(value);

        if(name === 'u_company_num')  value = biznumFormat(value,1);
        if(name === 'u_area'){
            loadAgency(value)
        }

        

        if(name === 'u_brand'){
            brand.push(value)
        }

        if(name === 'u_car_f' || name === 'u_car_s' || name === 'u_car_l'){
            setCarNumber({
                ...carNumbers,
                [name]:value,
            })
        }else if(name === 'u_car_name' || name === 'u_car_number' || name === 'u_car_age' || name === 'u_car_color' || name === 'u_car_date'){
            setRepCar({
                ...repCar,
                [name]:value
            })
    
        }else{
            setInputs({
                ...inputs,
                [name]:value
            })
    
        }
        console.log('홀더', u_holder);
        




        
    }

    
    
    useEffect(() => {
        if(u_holder == u_nick){
            setcheckholder(1)
        }else if(u_holder == u_company_name){
            setcheckholder(1)
        }else{
            setcheckholder(0)
        }

        

    }, [u_holder,u_nick,u_company_name]);


    //비번 확인
    const [pw_input, setPwInput] = useState('');

    const onPwCheck = (e) => {
        const {value} = e.target;

        setPwInput(value);

    }

    // 마케팅 수신여부 
    const [chkInput, setChkInput] = useState({
        must:false,
        must2:false,
        u_agree:false,
    });

    let {must,must2,u_agree} = chkInput;

    const onChecked = (e) => {
        const {name, checked, value} = e.target;
        
        setChkInput({
            ...chkInput,
            [name]:checked
            
        });
    }
    


    // 회원가입 버튼 클릭
    const userInsert = () => {
        
        const {du_id,du_nick} = duInput;
        
 
        console.log('checkholder', checkholder);
        if(du_id !== true){
            alert('ID 중복체크를 해주세요.');
        }else if(pw_input !== u_pwd){
            alert('비밀번호와 비밀번호 확인란이 일치 하지않습니다.\n비밀번호를 다시 확인해주세요.');
        }else if(!must){
            alert("ABYS의 이용약관에 동의합니다.란은 필수입니다.");
        }else if(!must2){
            alert("개인정보 처리방침에 동의합니다.란은 필수입니다.");   
        }else{
            inputs.u_sigong = sigong.si_id;
            inputs.u_phone = inputs.u_phone.replace(/\-/g,'');
            inputs.u_dam_num = inputs.u_dam_num.replace(/\-/g,'');
            inputs.u_agree = u_agree;
            inputs.u_address1 = u_address1 + ' ' + u_address2;
            inputs.u_brand = JSON.stringify(checkedList);

            console.log('inputs are: ', inputs);
            if(insertCnt === 0){
                instance.post('/users/join',{
                    params: {
                        obj:  inputs,
                    }
                })
                .then(function (response) {
                    console.log('response : ', response)
                    insertCnt++;
                    alert('회원가입이 완료됐습니다.')
                    window.location.replace('/')
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
               
            }
            
        }
    }

    const borderNone = {border: '0'}
    const marginCss = {marginTop:'23px'}
    const uTypeStyle = {marginTop:"20px"}

    //다음 우편 서비스 

    const [isPost, setIsPost] = useState(false);

    const postModal = () => {
        setIsPost(!isPost);
    }

    const searchBtn = {
        position:'absolute',
        right:'0',
        color:'#0B4FA0'
    }

    const borderRadius = {
        borderRadius:'8px'
    }

    const isPc = useMediaQuery({
        query : "(min-width:768px)"
      });
    const isMobile = useMediaQuery({
        query : "(max-width:767px)"
    });

    console.log('is master: ', isMaster);
    return(
        <>
        <div>
            <div className="logo d-none">
                <Link to="/"><img className="logimg" src={Logo}></img></Link>
            </div>
            <div className="container Login2 text-left" style={{marginTop:'50px'}}>
                <div className="text-right">
                    <input className="mx-3" type="radio" onChange={onChange} id="customer" name="u_type" value="일반고객" checked={!isMaster} />
                    <label for="customer">일반고객</label>
                    <input className="mx-3" type="radio" onChange={onChange} id="sigong" name="u_type" value="시공지점" checked={isMaster} />
                    <label for="sigong">시공지점</label>
                    {/* <input className="mx-3" type="radio" onChange={onChange} id="car-master" name="u_type" value="카마스터" checked={isMaster} />
                    <label for="car-master">카마스터</label> */}
                </div>
                <h5 className="text-lightgray">회원가입</h5>
            </div>
            <div className="container Login2">
                <div className="login-form2">
                    <div>
                        <h3 className="font-weight-bold d-inline-block mr-3 mb-0">개인정보</h3>
                        {/* {isMaster && <CarStoreInfo u_dealer_agency={u_dealer_agency} setAgency={setAgency} isMaster={isMaster} />} */}
                        <div className="id">
                            <div className="input">ID</div>
                            <div className="idinput">
                                <input name="u_login_id" className="userId" type="text" value={u_login_id} onChange={onChange} />
                                <DupliSpan value={u_login_id} name="u_login_id" setDuInput={setDuInput} duInput={duInput}/><br/>
                            </div>
                        </div>
                        {
                            !kind &&
                            <>
                            <div className="input">비밀번호</div> 
                            <input name="u_pwd" className="password" type="password" value={u_pwd} onChange={onChange} /><br></br>
                            <div className="input">비밀번호 확인</div> 
                            <input id="checkPw" name="checkPw" className="password" type="password" onChange={onPwCheck} /><br></br>
                            </>
                        }
                        <div className="id">
                            {
                                u_type === '일반고객'
                                ?
                                <div className="input">성함</div>
                                :
                                <div className="input">대표자명</div>
                            }
                            
                            <div>
                                <input name="u_nick" className="userId" type="text" value={u_nick} onChange={onChange} />
                            </div>
                        </div>
                        <div className="id">
                        {
                                u_type === '일반고객'
                                ?
                                <div className="input">휴대폰번호</div>
                                :
                                <div className="input">대표자 연락처</div>
                            }
                            <div>
                                <input name="u_phone" className="userId" type="text" value={u_phone} onChange={onChange} />
                            </div>
                        </div>
                        <div>
                            {
                                u_type === '일반고객'
                                &&<>
                                <div className="id">
                                    <div className="input">주소</div>
                                    <div>
                                        <input 
                                            name="u_address1" 
                                            placeholder="주소를 입력해주세요." 
                                            className="userId" 
                                            type="text" 
                                            value={u_address1} 
                                            onChange={onChange}
                                            onClick={postModal}
                                            readOnly
                                        />
                                    </div>
                                </div>
                             
                                <div className="id">
                                    <div className="input">상세주소</div>
                                    <div>
                                        <input name="u_address2"  placeholder="상세주소를 입력해주세요." className="userId" type="text" value={u_address2} onChange={onChange} />
                                    </div>
                                </div>
                                </>
                                
                            }
                               {
                                    isPost && <Postcode inputs={inputs} setInputs={setInputs} isPost={isPost} setIsPost={setIsPost}/>
                                }
                            
                        </div>
                        {isMaster && <SigongInfo u_sigong={sigong} setSigong={setSigong} onChange={onChange} isMaster={isMaster} 
                        u_company_num = {u_company_num} u_company_name={u_company_name} u_bank = {u_bank} u_holder={u_holder}
                        u_account = {u_account} u_email={u_email} u_dam={u_dam} u_dam_num={u_dam_num} u_brand={u_brand} u_tv_tech={u_tv_tech} 
                        bChecked={bChecked} checkHandler={checkHandler} brandChange={brandChange} tvTech={tvTech} postModal={postModal} 
                        u_sa_address_1={u_sa_address_1} u_sa_address_2={u_sa_address_2} u_sa_address_3={u_sa_address_3} onCheckedElement={onCheckedElement} />}
                    </div>
                    
                </div> 
                <div className="rgft">
                <div className="checkbox">
                    <label className="lab"><input name="must" type="checkbox" value="" onChange={onChecked} checked={must}/> ABYS의 이용약관에 동의합니다.</label><MustModal type="이용약관"/><br/>
                    <label className="lab"><input name="must2" type="checkbox" value="" onChange={onChecked} checked={must2}/> 개인정보 처리방침에 동의합니다.</label><MustModal  type="개인정보"/><br/>
                    <label className="lab"><input name="u_agree" type="checkbox" value="" onChange={onChecked} checked={u_agree}/> 프로모션 및 마케팅 정보 수신에 동의합니다.(선택)</label><br/>
                </div>
                <div className="regbtn row p-0">
                    {
                        isMobile && 
                        <Link to="/" className="col pl-0">
                        <button type="button" className="btn btn-light w-100">취소</button>   
                        </Link>
                    }
                    {
                        isPc
                        ?
                        <div className="col-12 px-0">
                            <button type="button" className="btn btn-primary w-100" onClick={userInsert}>회원가입 완료</button>    
                        </div>
                        :
                        <div className="col pr-0">
                            <button type="button" className="btn btn-primary w-100" onClick={userInsert}>회원가입 완료</button>    
                        </div>
                    }                    
                </div>
                
                
                <div className="ft-3">
                    <span>회원가입시 ABYS의 서비스 이용약관과</span><br/><span>개인정보 보호정책에 동의하게 됩니다.</span>
                </div>
            </div>           
            </div>
            
            
        </div>    
        </>
    );
}






export default React.memo(Register);